module.exports = __webpack_public_path__ + "img/javis.a8842b4f.svg";